import {Component, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'la-search-bar',
  template: `
    <div class="la-search-input">
        <div class="la-search-input__background">
            <div class="left">
                <la-icon name="search" size="md"></la-icon>
            </div>
            <div class="la-search-input__input">
                <input type="search" placeholder="search" class="input-box" (keyup)="doSearch($event)">
            </div>
        </div>
    </div>
  `,
  styles: [`
    input:focus{border:0;box-shadow:none;outline:none}.la-search-input{display:inline-flex}.la-search-input__background{width:100%;display:flex;padding:10px 0;align-items:center;border-radius:8px;background:rgba(54,68,79,.05);margin:0 5px}.la-search-input__background .left{padding-left:10px}.la-search-input__input{background:transparent;margin:0 0 0 5px;padding-right:5px}.la-search-input__input .input-box{background:transparent;border:0}
  `],
  encapsulation: ViewEncapsulation.None
})
export class LaSearchBarComponent {
  doSearch(e: Event) {
    // write logic for the search method you wamt to implement
    console.log(e);
  }
}
